
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"76","height":"77","viewBox":"0 0 76 77","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#check-circle_svg__clip0)"}},[_c('path',{attrs:{"d":"M38 .5C17.013.5 0 17.513 0 38.5s17.013 38 38 38 38-17.013 38-38S58.987.5 38 .5zm0 7.415c16.903 0 30.585 13.68 30.585 30.585 0 16.903-13.68 30.585-30.585 30.585-16.903 0-30.585-13.68-30.585-30.585C7.415 21.597 21.095 7.915 38 7.915zm21.247 19.777l-3.452-3.478a1.839 1.839 0 00-2.6-.01L31.54 45.672l-9.16-9.229a1.84 1.84 0 00-2.6-.01l-3.48 3.45a1.837 1.837 0 00-.01 2.598l13.907 14.012c.715.72 1.879.725 2.6.01l26.44-26.212c.72-.715.725-1.878.01-2.599z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"check-circle_svg__clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 .5h76v76H0z"}})])])])
          )
        }
      }
    